import { ItemIconChain } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import { generateAutomationName } from "../../../helpers/generateAutomationName";

import { MAX_VERSUS_ICON_COUNT, VERSES_ICON_SIZE } from "./constants";
import * as SC from "./style";
import { VERSUS_TEXT } from "./text";
import type { PrimaryVersusSchema } from "./type";

export const PrimaryVersus = ({ favicons, primaryDomain, competitors }: PrimaryVersusSchema) => {
    const competitorsIcons = competitors.map((domain) => (favicons ? favicons[domain] : null));

    return (
        <SC.VersusWrapper data-automation={generateAutomationName("home", ["header", "versus", "wrapper"])}>
            <SC.MainDomainWrapper>
                <SC.MainDomainText>{primaryDomain}</SC.MainDomainText>
            </SC.MainDomainWrapper>

            <SC.VersusLabel>{translate(VERSUS_TEXT)}</SC.VersusLabel>

            <SC.ItemIconChainContainer className="versus-icons">
                <ItemIconChain
                    icons={competitorsIcons}
                    maxIconChain={MAX_VERSUS_ICON_COUNT}
                    size={VERSES_ICON_SIZE}
                    counterBoxWidth={VERSES_ICON_SIZE}
                />
            </SC.ItemIconChainContainer>
        </SC.VersusWrapper>
    );
};

PrimaryVersus.displayName = "PrimaryVersus";
